
import EDBox from '../../../../BaseComponents/EDBox/EDBox';
import EDGrid from '../../../../BaseComponents/GridComponents/EDGrid';
import EDTooltip from '../../../../BaseComponents/Tooltip/EDTooltip';
import EDTypography from '../../../../BaseComponents/Typography/EDTypography';
import { BisattningsRumDelPlacering_db_BOBisattningsrum_All__Associations_Del_All } from '../Queries/_QueryTypes/BisattningsRumDelPlacering';
import { useTheme } from '@mui/material/styles';
import { IBusinessDataFormContext } from '../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
interface IPlaceringInfo {
  rumBen: string | undefined;
  delBen: string | undefined;
  placeringID: string | undefined;
  placeringBen: string | undefined;
}
interface IProps {
  formContext?: IBusinessDataFormContext<any, unknown>;
  directUpdate?: boolean;
  gridSizes: { rows: number; columns: number }[];
  rooms: {
    header: string;
    value: number;
    delar: BisattningsRumDelPlacering_db_BOBisattningsrum_All__Associations_Del_All[];
  }[];
  room: number | undefined;
  placeringInfo: IPlaceringInfo;
  setPlaceringInfo?: React.Dispatch<React.SetStateAction<IPlaceringInfo>>;
}
export const PlaceringGrid: React.FunctionComponent<IProps> = ({
  formContext,
  directUpdate,
  gridSizes,
  rooms,
  room,
  placeringInfo,
  setPlaceringInfo,
}) => {
  const theme = useTheme();

  const renderGridItems = () => {
    return gridSizes.map((size, delIndex) => (
      <EDBox key={delIndex} width="100%">
        <EDTypography bold marginTop={2.5}>
          {rooms[room ?? -1]?.delar?.[delIndex]?.BENAMNING}
        </EDTypography>
        <EDBox display="flex" flexDirection="column" gap={0.5}>
          {Array.from({ length: size.rows }).map((_, row) => (
            <EDBox key={row} display="flex" gap={0.5}>
              {Array.from({ length: size.columns }).map((_, col) => {
                const buttonIndex = row * size.columns + col;
                const rumBen = rooms[room ?? -1]?.header ?? '';
                const delBen =
                  rooms[room ?? -1]?.delar?.[delIndex]?.BENAMNING ?? '';
                const placeringID =
                  rooms[room ?? -1]?.delar?.[delIndex]?._Associations
                    ?.Pos_All?.[buttonIndex]?.id;
                const placeringBen =
                  rooms[room ?? -1]?.delar?.[delIndex]?._Associations
                    ?.Pos_All?.[buttonIndex]?.BENAMNING ?? '';
                const upptagen =
                  rooms[room ?? -1]?.delar?.[delIndex]?._Associations
                    ?.Pos_All?.[buttonIndex]?.Upptagen;
                // Updated isActive check to match both placeringID and placeringBen
                const isActive =
                  placeringInfo.placeringID === placeringID ||
                  (placeringInfo.placeringBen === placeringBen &&
                    placeringInfo.rumBen === rumBen);
                return (
                  <EDTooltip
                    title={
                      isActive
                        ? 'Vald placering'
                        : upptagen
                        ? 'Upptagen'
                        : 'Ledig placering'
                    }
                    key={buttonIndex}
                  >
                    <EDBox
                      width={80}
                      key={buttonIndex}
                      sx={{
                        backgroundColor: isActive
                          ? theme.palette.primary.main
                          : theme.palette.grey[200],
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        ...(upptagen
                          ? {}
                          : {
                              '&:hover': {
                                outline: `3px solid ${theme.palette.primary.main}`,
                                outlineOffset: '-3px',
                              },
                            }),
                      }}
                      onClick={
                        setPlaceringInfo
                          ? () => {
                              if (!upptagen) {
                                setPlaceringInfo({
                                  rumBen,
                                  delBen,
                                  placeringID,
                                  placeringBen,
                                });
                                if (directUpdate) {
                                  formContext?.update([
                                    {
                                      operation: 'Values',
                                      associationName: 'SenasteHandelse',
                                      values: {
                                        PLACERING_EJ_MALL: rumBen
                                          ? placeringBen
                                            ? rumBen + ' ' + placeringBen
                                            : rumBen
                                          : '',
                                        PLACERING_ID: placeringID,
                                      },
                                    },
                                  ]);
                                }
                              }
                            }
                          : undefined
                      }
                    >
                      <EDTypography
                        sx={{
                          color: isActive
                            ? theme.palette.common.white
                            : upptagen
                            ? theme.palette.error.main
                            : theme.palette.common.black,
                          paddingY: 1.5,
                          fontWeight: upptagen ? 'bold' : 'normal',
                        }}
                        testId={
                          isActive
                            ? 'valdPlacering'
                            : upptagen
                            ? 'upptagenPlacering'
                            : 'ledigPlacering'
                        }
                      >
                        {placeringBen}
                      </EDTypography>
                    </EDBox>
                  </EDTooltip>
                );
              })}
            </EDBox>
          ))}
        </EDBox>
      </EDBox>
    ));
  };
  return <EDGrid>{renderGridItems()}</EDGrid>;
};
